import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    width: "100%",
    "@media (max-width: 499px)": {
      paddingBottom: "calc(68px + env(safe-area-inset-bottom) + 16px)",
      minHeight: "min-content",
    },
  },
  footer: {
    position: "fixed",
    left: "0",
    bottom: "0",
    right: "0",
    height: "68px",
    minHeight: "68px",
    maxHeight: "68px",
    display: "block",
    zIndex: 1000,
    backgroundColor: tokens.colorNeutralBackground1,
    textAlign: "center",
    ...shorthands.padding("12px", "0", "12px", "0"),
    ...shorthands.margin("0"),
    boxSizing: "border-box",
    ...shorthands.overflow("hidden"),
    "@media (max-width: 499px)": {
      height: "calc(68px + env(safe-area-inset-bottom))",
      minHeight: "calc(68px + env(safe-area-inset-bottom))",
      paddingBottom: "calc(12px + env(safe-area-inset-bottom))",
    },
    "& > button": {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      ...shorthands.margin("0", "auto"),
      ...shorthands.padding("8px", "16px"),
      columnGap: "4px",
      height: "44px",
      minHeight: "44px",
      maxHeight: "44px",
      width: "343px",
      maxWidth: "calc(100% - 32px)",
      lineHeight: "1",
      boxSizing: "border-box",
      verticalAlign: "top",
      ...shorthands.overflow("hidden"),
      "@media (max-width: 499px)": {
        maxWidth: "calc(100% - 16px)",
      },
      "& > *": {
        lineHeight: "1",
        verticalAlign: "middle",
      },
    },
  },
  backgroundHoverColor: {
    "& > button": {
      "&:hover": {
        backgroundColor: "#5432E6",
      },
    },
  },
  submitButton: {
    paddingLeft: "10px",
    height: "44px",
  },
  customInstructions: {
    width: "-webkit-fill-available",
    paddingLeft: "12px",
    paddingRight: "12px",
    marginTop: "13px",
    height: "190px",
    ...shorthands.borderRadius("4px"),
    fontSize: tokens.fontSizeBase300,
    fontFamily: tokens.fontFamilyBase,
    color: tokens.colorNeutralForeground4,
    resize: "none",
    backgroundColor: tokens.colorNeutralBackground1,
    touchAction: "manipulation",
    "@media (max-width: 499px)": {
      marginLeft: "12px",
      marginRight: "12px",
      fontSize: tokens.fontSizeBase400,
    },
  },
  customInstructionsContainer: {
    width: "-webkit-fill-available",
    height: "48px",
    backgroundColor: tokens.colorNeutralBackground3,
    justifyContent: "space-between",
    "@media (max-width: 370px)": {
      columnGap: "130px",
    },
  },
  customInstructionsText: {
    paddingLeft: "18px",
    paddingTop: "16px",
    fontWeight: tokens.fontWeightBold,
    "@media (max-width: 370px)": {
      paddingTop: "0",
    },
  },
  maxCharactersText: {
    paddingTop: "16px",
    paddingRight: "18px",
    fontSize: tokens.fontSizeBase200,
    "@media (max-width: 370px)": {
      paddingTop: "0",
    },
  },
  overCharacterLimit: {
    color: "#C32727",
    ...shorthands.borderColor("#C32727"),
    width: "-webkit-fill-available",
    paddingLeft: "12px",
    paddingRight: "12px",
    marginTop: "13px",
    height: "190px",
    resize: "none",

    fontFamily: tokens.fontFamilyBase,

    ...shorthands.borderRadius("4px"),
    "&:focus": {
      ...shorthands.borderColor("#C32727"),
      ...shorthands.outline("0px"),
    },
    "@media (max-width: 499px)": {
      marginLeft: "12px",
      marginRight: "12px",
      fontSize: tokens.fontSizeBase400,
    },
  },
  errorMessage: {
    color: "#C32727",
    marginTop: "8px",
    fontSize: tokens.fontSizeBase300,
    fontFamily: tokens.fontFamilyBase,
    width: "100%",
    textAlign: "left",
    "@media (max-width: 499px)": {
      paddingLeft: "12px",
      paddingRight: "12px",
      fontSize: tokens.fontSizeBase400,
    },
  },
});
